<template>
  <div v-if="location">
    <b-row>
      <!-- Cargamos el mapa-->
      <b-col class="col-md-12 col-lg-4">
        <p>Ubicación geográfica</p>
        <div>
          <!--<google-map ref="mapaGoogle" />-->
          <vue-layers
            ref="mapa"
            :zoom="15"
            :key="selectedTab"
            class="mapa"
            :longitude="parseFloat(location.location.longitude)"
            :latitude="parseFloat(location.location.latitude)"
            :nodesCoordinates="nodesCoordinates"
          />
        </div>
      </b-col>

      <!-- Cargamos los datos -->
      <b-col class="col-md-12 col-lg-8 d-none d-sm-none d-md-block d-lg-block">
        <location-device-edit
          :location="location"
          @updated="refreshLocationData"
          @locationdeleted="locationDeleted"
          @editcancelled="editCancelled"
        />
      </b-col>
    </b-row>

    <!-- SPACER-->
    <spacer-card />

    <b-row>
      <b-col>
        <devices-details ref="devicesDetails" :location="location" />
      </b-col>
    </b-row>
  </div>

  <!-- Others-->
</template>

<script>
//import GoogleMap from "@/components/maps/GoogleMap";
import Spacer from "@/components/card/Spacer";
import VueLayers from "@/components/maps/VueLayers";
import LocationDeviceEdit from "@/components/devices/LocationDeviceEdit";
import DevicesDetails from "@/components/devices/DevicesDetails";
import DeviceService from "@/services/DeviceService";

//Ver https://bootstrap-vue.org/docs/components/tabs para mas info
export default {
  props: ["location", "selectedTab"],
  watch: {
    //Hack the :key y watch para saber en qué tabs estamos y forzar
    //el refresco del mapa de forma reactiva
    selectedTab: function (newVal, oldVal) {
      return newVal
    },
  },
  data() {
    return {
      nodesCoordinates: [],
    };
  },
  components: {
    //GoogleMap,
    VueLayers,
    LocationDeviceEdit,
    DevicesDetails,
    "spacer-card": Spacer,
  },
  methods: {

    locationDeleted(id) {
      this.$emit("locationdeleted", id);
    },

    refreshLocationData(location) {
      this.$refs.devicesDetails.selectedLocation = location.alias;
    },

    editCancelled() {
      this.$emit("editcancelled");
    },

    async getCoordinatesList() {
      if (this.location && this.location._id) {
        await DeviceService.getDevicesFromLocation(this.location._id)
          .then(async (response) => {
            let nodeList = response.data;

            if (nodeList && nodeList.length > 0) {
              for await (let node of nodeList) {
                if (
                  node.location.longitude &&
                  parseFloat(node.location.longitude) != NaN &&
                  node.location.latitude &&
                  parseFloat(node.location.latitude) != NaN
                ) {
                  let coordinatePair = {
                    latitud: parseFloat(node.location.longitude),
                    longitud: parseFloat(node.location.latitude),
                    alias: node.alias ? node.alias : ""
                  };
                  this.nodesCoordinates.push(coordinatePair);
                }
              }
            }
          })
          .catch((err) => {
            console.log("Error recuperando lista de coordenadas de nodos");
            console.log(err);
          });
      }
    },
  },
  async mounted(){
    await this.getCoordinatesList()
  }
};
</script>

<style scoped>
.mapa {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  height: 400px;
  padding: 5px;
}

p {
  padding-left: 10px;
}
</style>